import { default as content } from '../content/en'
import config from '../config/properties.json'
export default function Header() {

  const BikerMobileLogo = () => (
    <a href={config.externalWebsiteUrl} className="header-logo-link" target="_blank">
      <img
        className="header-logo"
        src="/assets/biker_mobile_logo_notext.png"
        alt="Biker Mobile Logo"

      />
    </a>
  );

  const BikerMobileLogoText = () => (
    <a href={config.externalWebsiteUrl} className="header-company-name" target="_blank">
      <img

        src="/assets/biker_mobile_company_name.png"
        alt="Biker Mobile Logo"
      />
    </a>
  );

  const AirAmbulanceLogo = () => (
    <a href="https://www.airambulancesuk.org/" target="_blank">
      <img
        className="air-ambulance-logo"
        src="/assets/air_ambulance_logo.png"
        alt="Air Ambulance Logo"
      />
    </a>
  );

  return (
    <>
      {/* Global Header with centered menu */}
      <div className="header">
        <div className="header-left">
          <BikerMobileLogo />
          <BikerMobileLogoText />

          {/* Center: Menu Buttons */}
          {/*
          <div className="mid-header">
            <button
              className="nav-btn"
              onClick={() => window.dispatchEvent(new CustomEvent('goToStep', { detail: { step: 1 } }))}
            >
              Plans
            </button>
            <button className="nav-btn">
              Already have a SIM?
            </button>
            <button className="nav-btn">
              Switching
            </button>
          </div>
          */}

          {/* Right: Basket Icon */}
          {/* <div className="header-basket">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              stroke="#FFFFFF"
            >
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <path d="M16 10a4 4 0 0 1-8 0"></path>
            </svg>
          </div> */}
        </div>
        <div className="header-right">
          <div className="biker-mobile-supports">{content.header.fundingSupport}</div>
          <div className="air-ambulance-logo-div">
            <AirAmbulanceLogo />
          </div>
        </div>
      </div>

    </>
  );
}
